import { BaseRestRepository } from './baseRestRepository';
import type {
  MeetingScheduleDto,
  CreateMeetingScheduleDto,
  MeetingScheduleDtoPaginationDto,
  UpdateMeetingScheduleDto,
} from '~/swagger/Api';

const MEETING_SCHEDULES_URL = '/api/meetings/schedules';

export const ONBOARDING_MEETING_IDENTIFIER = 'onboarding';

export class MeetingRepository extends BaseRestRepository {
  public async getMeetingSchedules(): Promise<MeetingScheduleDtoPaginationDto> {
    const response = await this.fetchWithAuth(MEETING_SCHEDULES_URL, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async createMeetingSchedule(payload: CreateMeetingScheduleDto): Promise<MeetingScheduleDto> {
    const response = await this.fetchWithAuth(MEETING_SCHEDULES_URL, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async updateMeetingSchedule(meetingScheduleId: string, payload: UpdateMeetingScheduleDto): Promise<MeetingScheduleDto> {
    const url = `${MEETING_SCHEDULES_URL}/${meetingScheduleId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteMeetingSchedule(meetingScheduleId: string): Promise<void> {
    const url = `${MEETING_SCHEDULES_URL}/${meetingScheduleId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}

export const meetingRepository = new MeetingRepository();
